import { MatterSubItemContextMenu } from "@/components/features/matter/context-menus/MatterSubItemContextMenu";
import type { Matter } from "@/lib/types";
import type { ReactNode } from "react";

interface MatterTreatmentPlanContextMenuProps {
  canDelete: boolean;
  date?: string | null;
  description?: string | null;
  id: string;
  isDeleting: boolean;
  matter: Matter;
  onDelete: () => Promise<void>;
  onEdit: () => void;
  status?: string | null;
  trigger: ReactNode;
}

export const MatterTreatmentPlanContextMenu = ({
  canDelete,
  date,
  description,
  id,
  isDeleting,
  matter,
  onDelete,
  onEdit,
  status,
  trigger,
}: MatterTreatmentPlanContextMenuProps) => {
  const entityLabel = description?.trim() || "treatment plan item";

  return (
    <MatterSubItemContextMenu
      copyValue={[
        entityLabel,
        date ? `Date: ${date}` : undefined,
        status ? `Status: ${status}` : undefined,
      ]
        .filter(Boolean)
        .join("\n")}
      delete={canDelete ? { disabled: isDeleting, onSelect: onDelete } : false}
      entityLabel={entityLabel}
      entityName="treatment plan item"
      matter={matter}
      onEdit={onEdit}
      subItem={{ id, type: "medical-treatment-plan" }}
      trigger={trigger}
    />
  );
};
